/**
 * Agent Directory types (PP-3997).
 *
 * Separate from the existing `Agent` type in `@/types` (avatar-only, used by `AgencyAgents`).
 * Mirrors `agency-directory-service` OpenAPI `POST /agents/search`
 * (`SearchPublicAgentsRequest`, `PublicAgentSearchRecord`) and the agency-profile-vue agent enums.
 */

export type PackageTier = 'RE_GOLD' | 'RE_SILVER' | 'RE_BRONZE' | 'RE_STARTER' | null;

/** Service enum values (`AgencyProfileServicesEnum`). */
export enum AgentService {
  RealEstateManagement = 'realEstateManagement',
  Sales = 'sales',
  Marketing = 'marketing',
  GeneralContracting = 'generalContracting',
  Valuation = 'valuation',
}

/** Specialization enum values (`AgencySpecialization`). */
export enum AgentSpecialization {
  InitialMarketing = 'initialMarketing',
  CommercialOffice = 'commercialOffice',
  InvestmentProperties = 'investmentProperties',
  FirstRentals = 'firstRentals',
  LuxuryProperties = 'luxuryProperties',
}

/** `PublicAgentSearchRecord` from `POST /agents/search`. */
export interface AgentProfile {
  agentId: number;
  firstName: string;
  lastName: string;
  agencyName: string;
  headAgencyId: string;
  profilePageUrlKeyword: string;
  avatarUrl: string | null;
  agencyLogoUrl: string | null;
  cityLocation: string | null;
  packageTier: PackageTier;
  services: AgentService[];
  specializations: AgentSpecialization[];
  propertiesBuyCount: number;
  propertiesRentCount: number;
  propertiesSoldCount?: number;
}
